<template>
  <div>
    <form @submit.prevent="addOrder">
      <input
        type="radio"
        id="one"
        :value="true"
        v-model="for_myself"
        @change="handleForMyself"
      />
      <label for="one">Dla siebie</label>
      <br />
      <input
        type="radio"
        id="two"
        :value="false"
        v-model="for_myself"
        @change="handleForMyself"
      />
      <label for="two">Dla kogoś</label>
      <br />
      <br />
      <label for="">Imie</label>
      <input type="text" class="form-control" v-model="firstName" />
      <label for="">Nazwisko</label>
      <input type="text" class="form-control" v-model="lastName" />
      <label for="">Ulica</label>
      <input type="text" class="form-control" v-model="street" />
      <label for="">Nr budynku</label>
      <input type="text" class="form-control" v-model="number1" />
      <label for="">Numer mieszkania</label>
      <input type="text" class="form-control" v-model="number2" />
      <label for="">Piętro</label>
      <input type="text" class="form-control" v-model="floor" />
      <label for="">Kod pocztowy</label>
      <input type="text" class="form-control" v-model="postcode" />
      <label for="">Miasto</label>
      <input type="text" class="form-control" v-model="city" />
      <label for="">Telefon</label>
      <input type="text" class="form-control" v-model="phone" />
      <label for="">Data urodzenia</label>
      <input type="text" class="form-control" v-model="birthdate" />
      <label for="">Email</label>
      <input type="text" class="form-control" v-model="email" />
      <label for="">Kod promocyjny użytkownika</label>
      <br />
      <select v-model="selectedPromotionalCode">
        <option selected value="">Brak</option>
        <option
          v-for="code in userPromotionalCodes.promotionalCodes"
          :key="code.promotional_code.id"
          :value="code.id"
        >
          {{ code.promotional_code.code }} -
          {{
            code.promotional_code.type === "ORDER_DISCOUNT"
              ? `Zniżka ${code.promotional_code.value * 100}%`
              : `Zniżka ${code.promotional_code.value}zł`
          }}
        </option>
      </select>

      <br />
      <label class="mt-4" for="orderStatus">Status zamówienia</label>
      <br />
      <select
        class="mb-4"
        name="orderStatus"
        v-model="selectedInitialOrderStatus"
      >
        <option
          v-for="initialOrderStatus in availableInitialOrderStatuses"
          :key="initialOrderStatus"
          :value="initialOrderStatus"
        >
          {{ initialOrderStatus }}
        </option>
      </select>

      <label for="customerNote">Dodatkowe informacje</label>
      <textarea
        id="customerNote"
        class="form-control mb-3"
        v-model="customerNote"
        rows="3"
        maxlength="1024"
        placeholder="Wpisz dodatkowe informacje dla opiekuna (opcjonalnie)"
      ></textarea>

      <button
        type="submit"
        class="form-control btn btn-outline-dark"
        :disabled="inProgress"
      >
        Dodaj zamówienie
      </button>
    </form>
  </div>
</template>

<script>
import axios from "../axios";
import moment from "moment";
export default {
  props: {
    days: {
      type: Array,
      required: true,
    },
    selectedService: {
      type: String,
      required: true,
    },
    userProfile: {
      type: Object,
      required: true,
    },
    userPromotionalCodes: {
      required: true,
    },
    previousOrder: {
      type: Object,
      required: false,
    },
  },
  emits: ["orderAdded"],
  name: "OrderForSeniorCustomerData",
  data() {
    return {
      loading: false,
      inProgress: false,

      firstName: "",
      lastName: "",
      street: "",
      number1: "",
      number2: "",
      floor: "",
      postcode: "",
      city: "",
      phone: "",
      birthdate: "",
      email: "",
      customerNote: "",
      time: "NONE",
      for_myself: true,
      selectedPromotionalCode: "",
      selectedInitialOrderStatus: "WAITING",
    };
  },
  watch: {
    availableInitialOrderStatuses: {
      immediate: true,
      handler() {
        this.selectedInitialOrderStatus = this.availableInitialOrderStatuses[0];
      },
    },
    userProfile: {
      immediate: true,
      handler() {
        if (this.userProfile && this.userProfile.user_profile) {
          this.setDataToOrder();
        }
      },
    },
    previousOrder: {
      immediate: true,
      handler() {
        if (this.previousOrder) {
          this.setDataToOrder();
        }
      },
    },
  },
  async created() {
    if (this.userProfile && this.userProfile.user_profile) {
      this.handleForMyself();
    }
  },

  methods: {
    handleForMyself() {
      if (!this.previousOrder) {
        if (this.for_myself) {
          const user = this.userProfile.user_profile;
          this.firstName = user.profile.first_name;
          this.lastName = user.profile.last_name;
          this.street = user.profile.street;
          this.number1 = user.profile.number1;
          this.number2 = user.profile.number2;
          this.floor = user.profile.floor;
          this.postcode = user.profile.postcode;
          this.city = user.profile.city;
          this.phone = user.user.phone;
          this.birthdate = user.profile.birthdate;
          this.email = user.profile.email;
        }
        if (!this.for_myself && this.userProfile) {
          this.getClosePersonData();
        }
      }
    },

    getClosePersonData() {
      axios
        .get(`api/close-person?userId=${this.userProfile.user_profile.user.id}`)
        .then((response) => {
          const user = response.data;
          this.firstName = user.first_name;
          this.lastName = user.last_name;
          this.street = user.street;
          this.number1 = user.number1;
          this.number2 = user.number2;
          this.floor = user.floor;
          this.postcode = user.postcode;
          this.city = user.city;
          this.phone = user.phone;
          this.birthdate = user.birthdate;
          this.email = user.email;
        });
    },

    setDataToOrder() {
      if (this.previousOrder) {
        this.for_myself =
          this.previousOrder.for_myself === "Dla siebie" ||
          this.previousOrder.for_myself === true;
        this.firstName =
          this.previousOrder.crs_first_name ||
          this.previousOrder.customerProfile?.first_name ||
          "";
        this.lastName =
          this.previousOrder.crs_last_name ||
          this.previousOrder.customerProfile?.last_name ||
          "";
        this.street =
          this.previousOrder.street ||
          this.previousOrder.customerProfile?.street;
        this.number1 =
          this.previousOrder.number1 ||
          this.previousOrder.customerProfile?.number1;
        this.number2 =
          this.previousOrder.number2 ||
          this.previousOrder.customerProfile?.number2;
        this.floor =
          this.previousOrder.floor || this.previousOrder.customerProfile?.floor;
        this.postcode =
          this.previousOrder.postcode ||
          this.previousOrder.customerProfile?.postcode;
        this.city =
          this.previousOrder.city || this.previousOrder.customerProfile?.city;
        this.phone =
          this.previousOrder.crs_phone ||
          this.previousOrder.ordered_user_phone ||
          this.previousOrder.customerProfile?.phone;
        this.birthdate = this.previousOrder.birthdate
          ? moment(this.previousOrder.birthdate).format("YYYY-MM-DD")
          : this.previousOrder.customerProfile?.birthdate
          ? moment(this.previousOrder.customerProfile?.birthdate).format(
              "YYYY-MM-DD"
            )
          : "";
        this.email =
          this.previousOrder.crs_email ||
          this.previousOrder.customerProfile?.email ||
          "";
        this.customerNote = this.previousOrder.customerProfile?.note || "";
      } else if (this.userProfile && this.userProfile.user_profile) {
        const user = this.userProfile.user_profile;
        this.firstName = user.profile.first_name;
        this.lastName = user.profile.last_name;
        this.street = user.profile.street;
        this.number1 = user.profile.number1;
        this.number2 = user.profile.number2;
        this.floor = user.profile.floor;
        this.postcode = user.profile.postcode;
        this.city = user.profile.city;
        this.phone = user.user.phone;
        this.birthdate = user.profile.birthdate;
        this.email = user.profile.email;
        this.customerNote = user.profile.note || "";
      }

      this.selectedPromotionalCode = "";
    },

    async addOrder() {
      this.inProgress = true;
      const order_days = this.days.map((day) =>
        moment(day.date).format("YYYY-MM-DD 20:00:00.000")
      );
      const body = {
        customer_request: {
          first_name: this.firstName,
          last_name: this.lastName,
          street: this.street,
          number1: this.number1,
          number2: this.number2,
          floor: this.floor,
          postcode: this.postcode,
          city: this.city,
          phone: this.phone,
          birthdate: this.birthdate,
          email: this.email,
          note: this.customerNote || "",
        },
        time: this.time,
        for_myself: this.for_myself,
        from_admin: true,
        customer_phone:
          this.userProfile?.user_profile?.user?.phone ||
          this.previousOrder.ordered_user_phone,
        order_days,
        promotion_id: this.selectedPromotionalCode,
        initial_order_status: this.selectedInitialOrderStatus,
      };
      await axios
        .post(`/api/order/${this.selectedService}`, body)
        .then((response) => {
          if (response && response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano zamówienie",
            });
            this.customerNote = "";
          }
          this.inProgress = false;
          this.$emit("orderAdded");
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.error === "not_enough_money"
          ) {
            this.$notify({
              group: "error",
              text: "Użytkownik nie posiada wystarczająco pieniędzy w portfelu, aby zamówić usługę",
            });
          } else if (
            err.response &&
            err.response.data &&
            err.response.data.error === "invalid_birthdate"
          ) {
            this.$notify({
              group: "error",
              text: "Data urodzenia musi być w formacie YYYY-MM-DD",
            });
          } else {
            this.$notify({
              group: "error",
              text: "Nie udało się dodać zamówienia",
            });
          }

          this.inProgress = false;
        });
    },
  },
  computed: {
    availableInitialOrderStatuses() {
      //if all selected day in 'days' are from the past, then only 'FINISHED' status is available
      if (
        this.days.length > 0 &&
        this.days.every((day) =>
          moment(day.date).startOf("day").isBefore(moment().startOf("day"))
        )
      ) {
        return ["FINISHED"];
      }

      //if one of the selected days is in the future, then 'ACCEPTED'
      if (this.days.length > 0) {
        return ["WAITING", "ACCEPTED"];
      }
      return ["WAITING", "ACCEPTED", "FINISHED"];
    },
  },
};
</script>

<style scoped>
div {
  padding: 0;
}
</style>
